export default __webpack_public_path__ + "static/fininscase5-f928d8bee7c54de70b436a49c3e6c3c2.png";